export enum ProfileTabs {
  general = "general",
  subscriptions = "subscriptions",
}

export interface ITabPanelProps {
  open: boolean;
}
